import React from 'react';
import {Link} from 'react-router-dom';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DropdownButton, MenuItem } from 'ui';
import ModalRow from './ModalRow';
import { 
  WRAP_STYLE, 
  formatProjectDate, 
  getProjectDisplayName, 
  getOwnerDisplay 
} from './projectRowUtils';

/**
 * Base component for project rows with common structure
 * @param {object} props - Component props
 * @param {object} props.project - The project object
 * @param {function} props.onHide - Function to hide modal
 * @param {React.ReactNode} props.projectNameContent - Custom content for project name cell
 * @param {React.ReactNode[]} props.menuItems - Array of MenuItem components
 * @returns {React.Component}
 */
function BaseProjectRow(props) {
  if (!props.project || !props.project.id) return <div></div>;

  const ownerDisplay = props.project.owner;
  const displayDate = formatProjectDate(props.project.updated_at);
  const displayName = getProjectDisplayName(props.project.name);

  return (
    <ModalRow
      row={[
        <div style={WRAP_STYLE} className='projectRow'>
          {props.projectNameContent || displayName}
        </div>,
        <div style={WRAP_STYLE}>{getOwnerDisplay(ownerDisplay)}</div>,
        <div style={WRAP_STYLE}>{displayDate}</div>,
        <DropdownButton
          variant="link"
          title={<MoreVertIcon data-testid="MoreVertIcon" style={{color:"black", fontSize: 16}}/>}
          id={1}
          noCaret
          pullRight
          style={{padding:0, margin:0}}
        >
          {props.menuItems}
        </DropdownButton>
      ]}
    />
  );
}

export default BaseProjectRow;